"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryBar = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Component for displaying a list of categories under the hero banner. Used on front-page, plp, brands ...
 **/
const CategoryBar = ({
  activeLink,
  className,
  fontColor,
  linkData,
  useOnlyExternalActiveLink,
  onClick,
  linkComponent
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [value, setValue] = (0, _react.useState)(activeLink?.id);
  const activeValue = activeLink?.id ?? value;
  const handleTabClick = (0, _react.useCallback)((link, index) => event => {
    const indexPlusOne = index + 1;
    const withSegmentData = [..._constants.CATEGORY_CLICK_EVENT_HIERARCHY, link.relativeUrl, link.title, indexPlusOne.toString()];
    UserAction.dispatch(withSegmentData);
    if (onClick) {
      event.preventDefault();
      onClick(link);
    }
  }, [onClick]);
  const onChange = (0, _react.useCallback)((_, id) => setValue(id), []);
  if (linkData.length < 1) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    allowScrollButtonsMobile: true,
    scrollButtons: true,
    "data-testid": getTestId(_constants.CATEGORY_BAR_TEST_ID),
    variant: "scrollable",
    slots: _constants.SLOTS,
    value: useOnlyExternalActiveLink ? activeLink?.id : activeValue,
    className: className,
    onChange: onChange,
    children: linkData.map((link, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Item, {
      LinkComponent: linkComponent ?? 'a',
      href: link.relativeUrl,
      value: link.id,
      icon: link.icon,
      iconPosition: link.iconPosition,
      id: link.title,
      "data-testid": getTestId(_constants.CATEGORY_BAR_TEST_ID_ITEM),
      hoverActiveColor: fontColor,
      label: link.title,
      tabIndex: 0,
      order: index,
      onClick: handleTabClick(link, index)
    }, link.id))
  });
};
exports.CategoryBar = CategoryBar;
